'use client';

import { useState } from 'react';
import { HierarchicalMenu, useCurrentRefinements } from 'react-instantsearch';

import { DynamicFilterMobile } from '@/components/atomic/molecules';

const classNameGroup = {
  checkbox:
    'content-searchkit-checkbox searchkit-checkbox checked:content-searchkit-checkbox-checked',
  noResults: 'searchkit-no-result-found min-h-48',
  count: 'bg-brand text-white border-none font-medium text-xs',
  labelText:
    'text-sm text-dim-gray font-medium searchkit-label-text cursor-pointer',
  list: 'flex flex-col gap-2 overflow-x-hidden overflow-y-auto w-80 min-h-48 max-h-80',
  item: 'pr-2',
  searchBox: 'searchkit-search-box',
  selectedItem: 'searchkit-selected-item',
  showMore: 'searchkit-filter-show-more-button'
};

const getCountForHierarchicalAttribute = ({
  baseAttributePrefix,
  currentRefinements
}) => {
  let countOfHierarchicalAttributes;
  return currentRefinements.reduce((count, refinement) => {
    if (refinement.attribute.startsWith(baseAttributePrefix)) {
      countOfHierarchicalAttributes = refinement.refinements.length;
    }
    return countOfHierarchicalAttributes;
  }, 0);
};

const SearchSortFilterProductsMobileOrganism = () => {
  const [openFilter, setOpenFilter] = useState(null);

  const { items: currentRefinements } = useCurrentRefinements();

  const handleToggleFilter = (attribute) => {
    setOpenFilter((prevOpenFilter) =>
      prevOpenFilter === attribute ? null : attribute
    );
  };

  const dynamicFilterList = [
    {
      attribute: 'categoryLevels.level_',
      buttonName: 'Category',
      Component: HierarchicalMenu,
      componentProps: {
        attributes: [
          'categoryLevels.level_0',
          'categoryLevels.level_1',
          'categoryLevels.level_2'
        ],
        classNames: {
          ...classNameGroup,
          childList: '!mt-2',
          label:
            'text-sm text-dim-gray font-medium searchkit-label-text cursor-pointer',
          list: 'flex flex-col gap-3',
          root: 'searchkit-search-box-event-type max-h-96'
        }
      },
      count: getCountForHierarchicalAttribute({
        baseAttributePrefix: 'categoryLevels.level_',
        currentRefinements
      }),
      icon: 'categories-brand-icon.svg',
      isOpen: openFilter === 'categoryLevels.level_',
      onClearAllRefinement: () => {
        handleToggleFilter();
      },
      onToggle: handleToggleFilter,
      selectedIcon: 'categories-white-icon.svg',
      setOpenFilter,
      showCount:
        getCountForHierarchicalAttribute({
          baseAttributePrefix: 'categoryLevels.level_',
          currentRefinements
        }) > 0
    }
  ];

  return (
    <div className='flex md:hidden mt-3'>
      <div className='flex border-l border-platinum gap-3 overflow-auto justify-start items-center pl-3'>
        {dynamicFilterList.map((filterProps, index) => (
          <DynamicFilterMobile
            key={index}
            {...{ filterProps }}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchSortFilterProductsMobileOrganism;
